<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <span slot="current">Tabular Datasets</span>
        <span slot="title">Tabular Datasets</span>
      </AffixHeader>

      <Row
        v-if="$can('create', 'datasets')"
        type="flex"
        justify="space-between"
      >
        <i-col>
          <i-button
            type="primary"
            @click="$router.push('/tabular-datasets/new')"
          >
            <FFIcon type="plus" />New Tabular Dataset
          </i-button>
        </i-col>
      </Row>
      <br />

      <Card dis-hover>
        <h3 slot="title">Search</h3>
        <i-form :model="form" :label-width="100" label-position="right">
          <i-form-item label="Name">
            <i-input v-model="form.name"></i-input>
          </i-form-item>

          <!-- <i-form-item label="Country">
            <CountrySelect
              v-model="form.country"
              filterable
              multiple
            ></CountrySelect>
          </i-form-item> -->

          <!-- <i-form-item label="Publishers">
            <SourceSelect v-model="form.source_id" multiple></SourceSelect>
          </i-form-item> -->

          <i-form-item label="Cause">
            <i-select v-model="form.displacement_type" filterable multiple>
              <i-option value="Conflict">Conflict</i-option>
              <i-option value="Disaster">Disaster</i-option>
              <i-option value="Development">Development</i-option>
            </i-select>
          </i-form-item>

          <i-form-item label="Created At">
            <Tooltip
              content="Double click for a single date."
              placement="top-start"
            >
              <DatePicker
                v-model="form.created_at"
                format="yyyy-MM-dd"
                type="daterange"
                style="width:100%;"
              ></DatePicker>
            </Tooltip>
          </i-form-item>

          <Row type="flex" justify="end" style="margin:12px 0;">
            <i-form-item class="action-buttons">
              <i-button icon="search" @click="search">Search</i-button>
              <i-button icon="close" @click="reset">Reset</i-button>
            </i-form-item>
          </Row>
        </i-form>
      </Card>

      <br />
      <DatasetsTable :conditions="conditions"></DatasetsTable>
    </i-col>
  </Row>
</template>

<script>
import moment from "moment";
// import CountrySelect from "@/components/country_select.vue";
// import SourceSelect from "@/components/source_select.vue";
import DatasetsTable from "./table.vue";
import { getTsQueryValue } from "@/utils/common";

const emptyForm = {
  name: "",
  country: [],
  displacement_type: [],
  created_at: [],
  source_id: [],
};

export default {
  components: {
    DatasetsTable,
    // CountrySelect,
    // SourceSelect
  },

  data() {
    return {
      form: Object.assign({}, emptyForm),
      conditions: {},
    };
  },

  methods: {
    search() {
      const conditions = {};

      // Name
      if (this.form.name !== "") {
        conditions["name"] = getTsQueryValue(this.form.name)
      }

      // Displacement Type
      if (this.form.displacement_type.length > 0) {
        conditions["displacement_type"] =
          "in.(" + this.form.displacement_type.toString() + ")";
      }

      // Country
      if (this.form.country.length > 0) {
        // @ts-ignore
        conditions["iso3"] = `in.("${this.form.country.join('","')}")`;
      }

      // Publishers
      if (this.form.source_id.length > 0) {
        const ids = this.form.source_id.join('","');
        conditions["source_id"] = `in.("${ids}")`;
      }

      // Created at
      if (this.form.created_at.length > 0) {
        const start = moment(this.form.created_at[0]);
        const end = moment(this.form.created_at[1]);
        if (start.isValid() && end.isValid()) {
          const startDate = start.format("YYYY-MM-DD");
          const endDate = end.format("YYYY-MM-DD");
          conditions[
            "and"
          ] = `(created_at.gte.'${startDate}',created_at.lte.'${endDate}')`;
        }
      }

      this.conditions = conditions;
    },

    reset() {
      this.form = Object.assign({}, emptyForm);
      this.conditions = {};
    },
  },
};
</script>

<style lang="scss" module>
.queries-link {
  font-weight: 600;
  text-transform: uppercase;
}
</style>
